import { Injectable } from '@angular/core';
import { BaseService } from '../../abstracts/base.service';
import { InstallmentModel } from '../../models/finance/installment.model';
import { InvoiceDetailModel } from '../../models/finance/invoice-detail.model';
import { InvoiceModel } from '../../models/finance/invoice.model';
import { TransactionModel } from '../../models/finance/transaction.mode';
import { ResultModel } from '../../models/result.model';
import { StudentModel } from '../../models/student.model';

@Injectable({
  providedIn: 'root'
})
export class InvoiceService extends BaseService {

  listAllForSelect(studentID: string = null) {
    if(studentID){
      return this.httpClient.get<ResultModel<InvoiceModel[]>>(this.getApiUrl(`invoices?pStudentID=${studentID}`));
    }
    else{
      return this.httpClient.get<ResultModel<InvoiceModel[]>>(this.getApiUrl('invoices'));
    }
  }

  listAll(formData:FormData) {
    return this.httpClient.post<ResultModel<InvoiceModel[]>>(this.getApiUrl('invoices/list'), formData);
  }

  create(invoice: InvoiceModel, transaction: TransactionModel) {
    
    var queryParams = '';
    queryParams += this.getQueryString(transaction);

    if (queryParams == '') {
      return this.httpClient.post<ResultModel>(this.getApiUrl('invoices'), invoice);
    }
    else {
      return this.httpClient.post<ResultModel>(this.getApiUrl("invoices?" + queryParams), invoice);
    }
  }

  update(invoice: InvoiceModel, transaction: TransactionModel) {

    var queryParams = '';
    queryParams += this.getQueryString(transaction);

    if (queryParams == '') {
      return this.httpClient.put(this.getApiUrl('invoices'), invoice);
    }
    else {
      return this.httpClient.put(this.getApiUrl("invoices?" + queryParams), invoice);
    }

    
  }

  get(id:string) {
    return this.httpClient.get<{ Invoice: InvoiceModel, InvoiceDetail: InvoiceDetailModel[],InstallmentAll:InstallmentModel[],InstallmentFirst:InstallmentModel,Transaction:TransactionModel[],Student:StudentModel }>(this.getApiUrl('invoices/' + id));
  }

  delete(id:string) {
    return this.httpClient.delete<ResultModel>(this.getApiUrl('invoices/' + id));
  }

}
